// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Ibc","colBig":"styles_colBig__uuIwG","colSmall":"styles_colSmall__1l6kq"};